import React, { createContext, useContext, useState, useEffect } from 'react';
import { buildApiUrl, getAuthHeaders } from '../config/api';

const RestaurantContext = createContext(null);

export function RestaurantProvider({ children }) {
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const res = await fetch(buildApiUrl('/restaurants/my'), { headers: getAuthHeaders() });
        const data = await res.json();
        if (data.code === 200 && data.data && data.data.length > 0) {

          setRestaurants(data.data);
          setSelectedRestaurant(data.data[0]);
          localStorage.setItem('RestaurantSize', data.data.length);    // 是否有餐厅 
          
        }
      } catch (err) {
        console.error('Failed to fetch restaurants', err);
      }
    };
    fetchRestaurants();
  }, []);

  return (
    <RestaurantContext.Provider value={{ restaurants, selectedRestaurant, setSelectedRestaurant }}>
      {children}
    </RestaurantContext.Provider>
  );
}

export function useRestaurant() {
  return useContext(RestaurantContext);
}
